import { GridColDef } from '@mui/x-data-grid';
import { GeoJSONFeatureCollection } from 'ol/format/GeoJSON';
import { SEVERITY_LABELS } from '../../constants/map.constants';
import {
    DeviceProperties,
    DeviceSetProperties,
    StackParams,
} from '../../models/models';
import DataTable from '../ui/data-table/data-table.component';

const DevicesetTable = ({
    devicesets,
    onRowSelected,
}: {
    devicesets: GeoJSONFeatureCollection;
    onRowSelected: (row: StackParams) => void;
}) => {
    const columns: GridColDef[] = [
        { field: 'name', headerName: 'Nome', flex: 0.8 },
        {
            field: 'status',
            headerName: 'Stato',
            flex: 0.2,
            cellClassName: (params) => {
                return `cell-status-${params.value}`;
            },
            valueFormatter: (value) => {
                return SEVERITY_LABELS[value];
            },
        },
    ];

    const getRows = () => {
        return devicesets.features.map((f: any) => {
            const properties = f.properties as
                | DeviceSetProperties
                | DeviceProperties;
            return {
                id: f.id,
                name: properties.name,
                status: properties.details.status_severity,
                content_type: properties.content_type,
            };
        });
    };

    return (
        <DataTable
            rows={getRows()}
            columns={columns}
            onRowSelected={onRowSelected}
            noRowSelection
        />
    );
};

export default DevicesetTable;
